import { Button, Icon, Modal, Notice } from "../../components/design";
import useTranslator from "../../hooks/useTranslator";
import styles from "./ApplicationCreatedModal.module.css";
import ApplicationPeopleSummary, {
  ApplicationMember,
} from "./ApplicationPeopleSummary";

type Props = {
  title: string;
  peopleCount: number;
  members?: ApplicationMember[];
  onClose: () => void;
};

const ApplicationCreatedModal = ({
  title,
  peopleCount,
  members,
  onClose,
}: Props) => {
  const { _t } = useTranslator();
  const handleGo = () => {
    onClose();
  };
  const subtitle =
    peopleCount <= 1
      ? _t("applyingOnYourOwn", "You're applying on your own")
      : _t(
          "applyingAsGroup",
          `You're applying with ${peopleCount} people`,
          undefined,
          { peopleCount: peopleCount }
        );

  return (
    <Modal
      open
      onClose={handleGo}
      dismissible={false}
      icon={
        <span className={styles.check}>
          <Icon name="check" size={28} />
        </span>
      }
      title={_t("applicationCreated", "Application created")}
      description={title}
      actions={
        <Button size="lg" block onClick={handleGo}>
          {_t("goToMyDashboard", "Go to my dashboard")}
        </Button>
      }
    >
      <p className={styles.subtitle}>{subtitle}</p>
      <ApplicationPeopleSummary members={members} />
      <Notice className={styles.notice}>
        {_t(
          "processingProfiles",
          "We're processing the profiles and we'll email you when everything is live"
        )}
      </Notice>
    </Modal>
  );
};

export default ApplicationCreatedModal;
